export function indexIsInRanges(index, ranges) {
    for (const range of ranges.subranges()) {
        if (range.low <= index && index <= range.high)
            return true;
        if (range.low > index)
            break;
    }
    return false;
}
